import { render, staticRenderFns } from "./PortalResultados.vue?vue&type=template&id=27cde613&"
import script from "./PortalResultados.vue?vue&type=script&lang=js&"
export * from "./PortalResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports